import { useAuth } from "@via/hooks/useAuth";
import { useGlobal } from "@via/hooks/useGlobal";
import { USER_ROLES } from "@via/utils/constants";

export const useImpersonationUser = () => {
  const { user } = useAuth();
  const isAdmin = user.userRole === USER_ROLES.ADMIN;
  const { impersonatedUserId } = useGlobal();
  return isAdmin && impersonatedUserId ? impersonatedUserId : undefined;
};
